import { Option } from 'commander';
import type { CommandInitFunction } from '../../types/CommandInitFunction.js';
import type { InitOptions } from './types/InitOptions.js';
import { reusedOptions } from '../../utilities/reusedOptions.js';

/** Defines the "init" verb. */
export const init: CommandInitFunction = (program) => {
  program.addSubCommand<InitOptions>({
    name: 'init',
    description:
      "Validate an app's compatibility with Cloudpack, and generate any necessary " +
      'configuration overrides (cloudpack.generated.json).',
    options: {
      logResolveMap: reusedOptions.logResolveMap(),
      logBundleInfo: reusedOptions.logBundleInfo({ requiresNoCache: true }),
      reset: new Option('--reset', 'Ignore the previous generated config.').conflicts('check'),
      check: new Option('--check', 'Fail if updates to the generated config are required.').conflicts('reset'),
      match: reusedOptions.match('Only evaluate specific package(s)').conflicts('reset'),
      cache: reusedOptions.cache(),
      app: reusedOptions.app({ multi: true }),
    },
    getExecutor: () => import('./execute.js'),
    // If the cwd isn't a cloudpack app, discover other cloudpack apps. Also handles --app.
    discoverAppPaths: 'multi',
  });
};
